<div>
  <button (click)="startRecording()">開始</button>
  <button (click)="stopRecording()">結束</button>
  <button (click)="discardRecording()">放棄</button>
  <button (click)="playRecording()">回放錄音</button>
  <button (click)="saveRecording()">存檔</button>
  @if (recordingTime > 0) {
  <div>
    錄音時間長度: {{ recordingTime }} 秒
  </div>
  }
</div>
